import { Widget } from '../../widget/widget';
import {
  DebatesTotalWidgetComponent,
  DebatesMeanVotesWidgetComponent,
  DebatesCertifiedWidgetComponent,
  DebatesCancelledWidgetComponent
} from '../../widget/widgets';

export const DebatesTotalWidget = (groupId) => {
  return new Widget(DebatesTotalWidgetComponent, {
    id: `widget-totals-${groupId}`,
    name: `widget-totals-${groupId}`,
    groupId
  });
};
export const DebatesMeanVotesWidget = (groupId) => {
  return new Widget(DebatesMeanVotesWidgetComponent, {
    id: `widget-mean-votes-${groupId}`,
    name: `widget-mean-votes-${groupId}`,
    groupId
  });
};
export const DebatesCertifiedWidget = (groupId) => {
  return new Widget(DebatesCertifiedWidgetComponent, {
    id: `widget-certified-${groupId}`,
    name: `widget-certified-${groupId}`,
    groupId
  });
};
export const DebatesCancelledWidget = (groupId) => {
  return new Widget(DebatesCancelledWidgetComponent, {
    id: `widget-cancelled-${groupId}`,
    name: `widget-cancelled-${groupId}`,
    groupId
  });
};
